export default [
    'chalk',
    'dark',
    'essos',
    'halloween',
    'infographic',
    'macarons',
    'purple-passion',
    'roma',
    'shine',
    'vintage',
    'walden',
    'westeros',
    'wonderland',
];
